module.exports = __webpack_public_path__ + "img/dashboard-icon.4cbd68be.svg";